import type { RouteRecordRaw } from 'vue-router';

const moduleName = 'session';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/session',
        name: moduleName,
        component: () => import('@/views/session/index.vue'),
        meta: {
            title: '当前会话',
            icon: 'zd-dangqianhuihua',
            badge: true,
            hideChildrenInMenu: true
        },
        children: [
            {
                path: '/order-detail',
                name: 'OrderDetail',
                component: () => import('@/views/order-detail/index.vue')
            },
            {
                path: '/goods-detail',
                name: 'GoodsDetail',
                component: () => import('@/views/goods-detail/index.vue')
            }
        ]
    }
];

export default routes;
